import React from 'react';
import PropTypes from 'prop-types';
import { Map, Marker, Polygon, TileLayer, ZoomControl, Popup } from 'react-leaflet';
import L from 'leaflet';
import { onlyUpdateForKeys, compose } from 'recompose';
import { translate } from 'react-i18next';

const tileUrl = L.Browser.retina
  ? 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}@2x.png'
  : 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}.png';

const icon = L.divIcon({
  html: '<div class="dot-region"></div>',
});
const activeIcon = L.divIcon({
  html: '<div class="dot-region active"></div>',
});
const enhance = compose(
  onlyUpdateForKeys(['points', 'editing']),
  translate(['geozones'], { wait: true })
);

export const GeozoneMap = enhance(({ points, position, editing, pointRemoveHandler, pointAddHandler, pointDragStartHandler, pointUpdateHandler, handleRef, t }) => (
  <Map
    center={position}
    ref={handleRef}
    style={{ height: '100%' ,stroke: "white"}}
    zoom={11}
    bounds={points.length > 2 ? points : undefined}
    color="white"
    zoomControl={false}
    className={editing ? 'editing' : ''}
    onClick={(e) => {
      if (editing) { pointAddHandler(e); }
    }}
    attributionControl={false}
  >
    <TileLayer detectRetina url={tileUrl} />
    <ZoomControl position="bottomright" />
    {points.length > 0 && <Polygon positions={points} /> }
    {points.map((point, i) => (
        <div>
          <Marker
            key={point.lat.toString() + point.lng.toString()}
            icon={i === (points.length - 1) ? activeIcon : icon}
            position={point}
            draggable={editing}
            onDragStart={(e) => {
              if (editing) {
                pointDragStartHandler(e);
              }
            }}
            onDragEnd={(e) => {
              if (editing) {
                pointUpdateHandler(e, i);
              }
            }}
            onClick={(e) => {
              if (editing) {
                // contextMenu.show(e, {
                //   id: `menu_${i}`,
                //   event: 'onClick'
                // });
              }
            }}
            opacity={(editing ? 1 : 0)}
          >
            { editing && (
                <Popup className='popup-wrapper'>
              <div className="popup-button" onClick={e => pointRemoveHandler(i)}>{t('geozones:new-geozone__remove')}</div>
                </Popup>
            )}
          </Marker>
        </div>
    ))}
  </Map>
));

// export const PointsList = pure(({ points, editing, pointRemoveHandler }) => (<div></div>));

GeozoneMap.propTypes = {
  points: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  })).isRequired,
  pointLatLng: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  position: PropTypes.arrayOf(PropTypes.number).isRequired,
  editing: PropTypes.bool.isRequired,
  pointRemoveHandler: PropTypes.func.isRequired,
  pointAddHandler: PropTypes.func.isRequired,
  handleRef: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Modal/GeozonesModal/GeozoneMapControls/GeozoneMap.js